<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view/>
</template>

<style>
* {
    user-select: none;
}
.order-6 {
    order: 6 !important;
}
.order-7 {
    order: 7 !important;
}
.order-8 {
    order: 8 !important;
}
.order-9 {
    order: 9 !important;
}
.order-10 {
    order: 10 !important;
}
.order-11 {
    order: 11 !important;
}

.h100 {
    height: 100vh;
}
.h25 {
    height: 25vh;;
}

.c-pointer {
    cursor: pointer;
}
</style>
